import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useMatch } from 'react-router-dom';

import { userSelectors } from 'reducers';

import IndirectSubscription from './IndirectSubscription';
import DirectSubscription from './DirectSubscription';

const InvestorTunnel = () => {
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const loggedIn = useSelector(userSelectors.getLoggedInStatus);
    const isCreatingSubscription = !!useMatch('/create-subscription/*');
    const location = useLocation();

    if ((loggedIn && tunnelSubscription?.indirectUntransferred) || isCreatingSubscription) {
        return (
            <Routes>
                <Route index element={<IndirectSubscription />} />
                <Route path=":stepId" element={<IndirectSubscription />} />
                <Route path="*" element={<Navigate to={location.pathname} replace />} />
            </Routes>
        );
    }
    return (
        <Routes>
            <Route index element={<DirectSubscription />} />
            <Route path=":stepId" element={<DirectSubscription />} />
            <Route path=":stepId/:tsId" element={<DirectSubscription />} />
            <Route path="*" element={<Navigate to={location.pathname} replace />} />
        </Routes>
    );
};

export default InvestorTunnel;
